import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import API_URL from '../../config';

const AddIncubationCenter = () => {
    const navigate = useNavigate();
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState('');

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: '',
        phone: '',
        city: '',
        state: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        try {
            setSubmitting(true);
            const response = await fetch(`${API_URL}/api/incubation/incubation-add`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const resData = await response.json();
            if (!response.ok || resData.success === false) {
                throw new Error(resData.message || "Failed to create incubation center");
            }

            toast.success("Incubation center added successfully!");
            navigate("/incubation/list");
        } catch (err) {
            setError(err.message || "Failed to save incubation center");
            toast.error(err.message || "Failed to save incubation center");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="container-fluid py-4">
            <div className="row">
                <div className="col-12">
                    <div className="card border-0 shadow-sm">
                        <div className="card-header border-bottom bg-transparent py-3">
                            <h5 className="mb-0 fw-semibold text-dark">Add New Incubation Center</h5>
                        </div>
                        <div className="card-body p-4">
                            {error && (
                                <div className="alert alert-danger mb-4" role="alert">
                                    {error}
                                </div>
                            )}
                            <form className="row g-3" onSubmit={handleSubmit}>
                                <div className="col-md-6">
                                    <label className="form-label text-secondary">Name *</label>
                                    <input type="text" className="form-control" name="name" placeholder="Enter center name" value={formData.name} onChange={handleChange} required />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label text-secondary">Email *</label>
                                    <input type="email" className="form-control" name="email" placeholder="Enter email address" value={formData.email} onChange={handleChange} required />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label text-secondary">Password *</label>
                                    <input type="password" className="form-control" name="password" placeholder="Min 6 characters" minLength={6} value={formData.password} onChange={handleChange} required />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label text-secondary">Phone Number *</label>
                                    <input type="text" className="form-control" name="phone" placeholder="Enter phone number" value={formData.phone} onChange={handleChange} required />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label text-secondary">City *</label>
                                    <input type="text" className="form-control" name="city" placeholder="Enter city" value={formData.city} onChange={handleChange} required />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label text-secondary">State *</label>
                                    <input type="text" className="form-control" name="state" placeholder="Enter state" value={formData.state} onChange={handleChange} required />
                                </div>

                                <div className="col-12 d-flex justify-content-end gap-2 mt-4">
                                    <button type="button" className="btn btn-secondary" onClick={() => navigate("/incubation/list")} disabled={submitting}>
                                        Cancel
                                    </button>
                                    <button type="submit" className="btn btn-primary" disabled={submitting}>
                                        {submitting ? "Adding..." : "Add Incubation Center"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddIncubationCenter;